import React from 'react';
import LegalProse from '../components/legal/LegalProse';

export function RefundContent() {
  return (
    <LegalProse>
      <p>
        We are using Razorpay (razorpay.com) to process payments in our website/app.
      </p>
      <p>
        As per the refund policy of Razorpay (https://razorpay.com/docs/payment-gateway/refunds/),
        if the contributor opts to avail refund, the amount will be reversed to the original payment
        method used in making the payment.
      </p>
      <p>
        For example, if a credit card was used to make the payment, the refund will be pushed to the
        same credit card. Razorpay does not charge any processing fee for refund. However, the
        transaction fee and GST levied by Razorpay at the time of payment capture will not be
        reversed to your account.
      </p>
      <p>
        Depending on the bank&apos;s processing time, it can take 5-7 business days for the refunds to
        reflect in the customer&apos;s bank account or card balance.
      </p>
    </LegalProse>
  );
}
